import { useState, useEffect } from "react";
import {
  useBuscarFunciones,
  actualizarFunciones,
  obtenerPerfilesAImportar,
  importarPerfil,
} from "../../Scripts/Services/funcionPerfilService.js";
import { formatData } from "../Utils/formatDataFuncion";
import { InnerTable } from "./InnerTable";
import { Column, DataTable, Skeleton, Dropdown } from "primereact";
import { BodyModulo } from "./BodyModulo";

export const FuncionesPerfil = () => {
  const url = new URL(window.location.href);
  const searchParamsLowerCase = new Map(
    [...url.searchParams.entries()].map(([key, value]) => [
      key.toLowerCase(),
      value,
    ])
  );
  const idSec = searchParamsLowerCase.get("idsec");
  const [nodes, setNodes] = useState([]);
  const [where, setWhere] = useState({ where: { IdSec: idSec } });
  const { data, loading, error } = useBuscarFunciones(where);
  const [expandedRows, setExpandedRows] = useState([]);
  const [checkList, setCheckList] = useState([]);
  const [todosCheckList, setTodosCheckList] = useState([]);
  const [moduloCheckList, setModuloCheckList] = useState([]);
  const [menusCheckList, setMenusCheckList] = useState([]);
  const [funcionesSinModulo, setFuncionesSinModulo] = useState([]);

  const [loadingGuardarButton, setLoadingGuardarButton] = useState(false);
  const [loadingImportarButton, setLoadingImportarButton] = useState(false);

  const [selectedPerfil, setSelectedPerfil] = useState(null);
  const [optionsPerfil, setOptionsPerfil] = useState([]);

  const [messages, setMessages] = useState([]);
  const [messagesClass, setMessagesClass] = useState(
    "message animated fadeIn warning"
  );

  const allowExpansion = (rowData) => {
    return rowData.children.length > 0;
  };

  const handleClickImportar = () => {
    if (selectedPerfil != null && selectedPerfil > 0) {
      setLoadingImportarButton(true);
      importarPerfil({
        where: {
          IdSec: idSec,
          PerfilImportarIdSec: selectedPerfil,
        },
      })
        .then((result) => {
          if (result.Resultado) {
            setWhere({ where: { IdSec: idSec } });
            setMessages((prev) => ["Perfil Importado Correctamente"]);
            setMessagesClass("message animated fadeIn ok");
          }
        })
        .catch((err) => {
          setMessages((prev) => [err.Mensaje]);
          setMessagesClass("message animated fadeIn error");
        })
        .finally(() => {
          setSelectedPerfil(null);
          setLoadingImportarButton(false);
        });
    } else {
      setMessages((prev) => ["Perfil seleccionado no valido"]);
      setMessagesClass("message animated fadeIn warning");
    }
  };

  const handleClickGuardar = () => {
    setLoadingGuardarButton(true);
    const funcionesIdSecList = [
      ...new Set([
        ...menusCheckList,
        ...checkList,
        ...funcionesSinModulo
          ?.filter((f) => f.Agregada === true)
          .map((f) => f.IdSec),
      ]),
    ];
    actualizarFunciones({
      where: {
        IdSec: idSec,
        FuncionesIdSecList: funcionesIdSecList,
      },
    })
      .then((result) => {
        if (result.Resultado) {
          setMessages((prev) => ["Grabado exitosamente"]);
          setMessagesClass("message animated fadeIn ok");
        }
      })
      .catch((err) => {
        setMessages((prev) => [err.Mensaje]);
        setMessagesClass("message animated fadeIn error");
      })
      .finally(() => setLoadingGuardarButton(false));
  };

  useEffect(() => {
    obtenerPerfilesAImportar({ where: {} })
      .then((resp) => {
        if (resp?.Resultado) {
          setOptionsPerfil(resp.Resultado);
        }
      })
      .catch((err) => {
        setMessages((prev) => [err.Mensaje]);
        setMessagesClass("message animated fadeIn error");
      });
  }, []);

  useEffect(() => {
    const elemento = document.getElementById(
      "ContentPH_ucFuncionesPerfil_ucToolbar_lkGrabar"
    );

    const handleClick = (e) => {
      e.preventDefault();
      handleClickGuardar();
    };

    if (elemento) {
      elemento.addEventListener("click", handleClick);
    }

    return () => {
      if (elemento) {
        elemento.removeEventListener("click", handleClick);
      }
    };
  }, [
    menusCheckList,
    checkList,
    funcionesSinModulo,
    idSec,
    setLoadingGuardarButton,
    setMessages,
    setMessagesClass,
    actualizarFunciones,
  ]);

  useEffect(() => {
    const dataFormated = formatData(
      data?.Funciones,
      data?.Modulos.sort((a, b) => a.Nombre.localeCompare(b.Nombre))
    );

    const funcionesConModuloCheck = dataFormated
      .flatMap((m) => m.children)
      .filter((f) => f.Agregada === true)
      .map((f) => f.IdSec);

    const finalDataFormated = dataFormated.filter(
      (d) => d.children?.length > 0
    );

    const menusCheckList = dataFormated
      .flatMap((m) => m.entidadesHijo)
      .flatMap((d) => d.Menus)
      .filter((f) => f.Agregada === true)
      .map((f) => f.IdSec);

    setMenusCheckList(menusCheckList);
    setCheckList(funcionesConModuloCheck);
    setNodes(finalDataFormated);
  }, [data]);

  useEffect(() => {
    const nuevosModuloCheckList = nodes.reduce((acc, modulo) => {
      if (modulo.entidadesHijo) {
        const todasEntidadesEnCheckList = modulo.entidadesHijo.every((e) =>
          todosCheckList.includes(e.Id)
        );

        if (todasEntidadesEnCheckList) {
          return [...acc, modulo.key];
        }
      }
      return acc.filter((p) => p !== modulo.key);
    }, []);

    setModuloCheckList(nuevosModuloCheckList);
  }, [todosCheckList]);

  useEffect(() => {
    const nuevosTodosCheckList = [];
    let nuevosMenusCheckList = [...menusCheckList];

    for (const modulo of nodes) {
      const funcionesModulo = modulo?.children;
      const funcionModulo = data?.Funciones.find(
        (f) => f.Nombre === modulo.FuncionMenu
      );
      if (
        funcionesModulo.some((f) => checkList.includes(f.IdSec)) &&
        funcionModulo
      ) {
        nuevosMenusCheckList = [...nuevosMenusCheckList, funcionModulo.IdSec];
      } else if (funcionModulo) {
        nuevosMenusCheckList = nuevosMenusCheckList.filter(
          (f) => f !== funcionModulo.IdSec
        );
      }
      for (const entidad of modulo.entidadesHijo) {
        const funciones = entidad?.Funciones;

        const todasFuncionesEnCheckList = funciones.every((f) =>
          checkList.includes(f.IdSec)
        );

        if (todasFuncionesEnCheckList) {
          nuevosTodosCheckList.push(entidad.Id);
        }
      }
    }

    setMenusCheckList(nuevosMenusCheckList);
    setTodosCheckList(nuevosTodosCheckList);
  }, [checkList]);

  useEffect(() => {
    const allFunctions = nodes
      .flatMap((n) =>
        n.entidadesHijo.flatMap((e) => [...e.Funciones, ...e.Menus])
      )
      .map((f) => f.IdSec);
    const allChecks = [...new Set([...menusCheckList, ...checkList])];
    const funcionesMenuModulos = nodes.map((n) => n.FuncionMenu);
    const funcionesModulo = data?.Funciones.filter((f) =>
      funcionesMenuModulos.some((fm) => fm === f.Nombre)
    ).map((f) => f.IdSec);
    const allFuncionesSinModulo = data?.Funciones.filter(
      (f) =>
        !allFunctions.includes(f.IdSec) &&
        !allChecks.includes(f.IdSec) &&
        !funcionesModulo.includes(f.IdSec)
    );
    setFuncionesSinModulo(allFuncionesSinModulo);
  }, [checkList, menusCheckList]);

  useEffect(() => {
    if (error) {
      setMessages((prev) => [error?.Mensaje]);
      setMessagesClass("message animated fadeIn error");
    }
  }, [error]);

  useEffect(() => {
    if (loadingGuardarButton || loadingImportarButton) {
      Citrus.UI.loading($("#container"), null, true);
    } else {
      Citrus.UI.loading($("#container"), null, false);
    }
  }, [loadingGuardarButton, loadingImportarButton]);

  return (
    <div>
      {messages?.length > 0 && (
        <div className={messagesClass} style={{ marginBottom: "10px" }}>
          <ul>
            {messages.map((m) => {
              return <li>{m}</li>;
            })}
          </ul>
        </div>
      )}
      <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        <span style={{ color: "navy", fontWeight: "bold" }}>
          Importar desde Perfil
        </span>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            <span style={{ marginTop: "7px" }}>Perfil Importar</span>
            <Dropdown
              options={optionsPerfil}
              style={{ height: "30px", width: "220px" }}
              value={selectedPerfil}
              showClear
              onChange={(e) => setSelectedPerfil(e.value)}
            />
            <div
              className="button"
              style={{
                width: loadingImportarButton ? "95px" : "75px",
                height: "10px",
                justifyContent: "center",
              }}
              onClick={loadingImportarButton ? () => {} : handleClickImportar}
            >
              <span
                style={{
                  fontSize: "15px",
                  fontWeight: "normal",
                  lineHeight: "20px",
                }}
              >
                Importar
              </span>
              {loadingImportarButton && <span className="girador"></span>}
            </div>
          </div>
        </div>
      </div>
      {!loading ? (
        <div>
          <DataTable
            className="main-table"
            showHeaders={false}
            style={{ marginTop: "20px" }}
            value={nodes}
            rowExpansionTemplate={(data) =>
              InnerTable(
                data,
                checkList,
                setCheckList,
                todosCheckList,
                setTodosCheckList,
                menusCheckList,
                setMenusCheckList
              )
            }
            expandedRows={expandedRows}
            onRowToggle={(e) => setExpandedRows(e.data)}
            expandedRowIcon="pi pi-chevron-up"
            collapsedRowIcon="pi pi-chevron-down"
          >
            <Column
              body={(data) =>
                BodyModulo(
                  data,
                  moduloCheckList,
                  setModuloCheckList,
                  setCheckList,
                  setExpandedRows,
                  setMenusCheckList
                )
              }
              expander={allowExpansion}
            />
            <Column expander style={{ width: "1rem" }} />
          </DataTable>
          <div
            className="button"
            style={{
              width: loadingGuardarButton ? "110px" : "80px",
              height: "10px",
              justifyContent: "center",
            }}
            onClick={loadingGuardarButton ? () => {} : handleClickGuardar}
          >
            <span
              style={{
                fontSize: "15px",
                fontWeight: "normal",
                lineHeight: "20px",
              }}
            >
              Guardar
            </span>
            {loadingGuardarButton && <span className="girador"></span>}
          </div>
        </div>
      ) : (
        <DataTable
          showHeaders={false}
          value={Array.from({ length: 30 })}
          style={{ marginTop: "40px" }}
        >
          <Column body={<Skeleton style={{ height: "40px" }} />} />
        </DataTable>
      )}
    </div>
  );
};
